import { cartLinkStyles } from "@insite/content-library/Widgets/Common/CartLink";
import { css } from "styled-components";

cartLinkStyles.routerLink = {
    typographyProps: {
        variant: "headerSecondary",
        transform: "none",
        css: css`
            white-space: nowrap;
            font-weight: 500;
        `,
        size: 16,
    },
    icon: {
        iconProps: {
            color: "secondary.contrast",
        },
    },
    color: "secondary.contrast",
    css: css`
        display: inline-block;
        text-align: center;
    `,
};
